/*
 * @Description: 脸书登陆组件
  和 google 保持统一 都用 code 换取 accessToken
  这里要注意后台给的 code 和 FB client 给的 code 完全不是一个东西，这里有坑，具体可以看
  https://stackoverflow.com/questions/10367049/facebook-server-side-authentication-flow-is-this-the-right-code

 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-15 17:26:44
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2022-04-27 16:26:22
 */

import { getRedirectUrl, isAppMarket } from '@tencent/syzs-login-sdk-utils';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import i18n from '../../i18n';
import { itemLoginTypeKey, postMessageToParent } from '../../lib';
import { ILoginType } from '../../types';
import './index.less';


const APP_ID = '958079241645886';

export interface IFaceBookLogin {
  name: string;
  id: string;
  accessToken: string;
  userID: string;
  expiresIn: number;
  signedRequest: string;
  graphDomain: string;
  data_access_expiration_time: number;
}

export const FaceBookLoginButton = () => {
  const responseFacebook = async () => {
    // NOT WORK !!!!! WE UESD REDIRECT
    // const signedRequest = JSON.parse(atob(response.signedRequest.split('.')[1]));

    // void code2AccessToken(signedRequest.code, ILoginType.fb);
  };


  return (
    <div className="login-v2-facebook-login">
      <FacebookLogin
        appId={APP_ID}
        autoLoad={false}
        scope="email,public_profile"
        callback={responseFacebook}
        render={() => (
          <div
            onClick={() => {
              window.report('syzs_login_v2_facebook_button_click');
              // 用自己重定向方式登陆
              localStorage.setItem(itemLoginTypeKey, ILoginType.fb);
              const url = `https://www.facebook.com/v12.0/dialog/oauth?client_id=${APP_ID}&redirect_uri=${encodeURIComponent(getRedirectUrl())}&scope=email`;
              if (isAppMarket()) {
                location.href = url;
              } else {
                void postMessageToParent('OPEN_LOGIN_PAGE', url, false);
              }
            }}
            className="facebook-button"
          >
            <i className="login-logo" />
            <span className="text">{i18n.l('FaceBookLogin')}</span>
          </div>
        )}
      />
    </div>
  );
};
